'use client';

import ShareButton from '@/components/next-page-components/ShareButton';
import useConnectModalStore from '@/components/store/connectModalSlice';
import useUserProfile from '@/hooks/useUserProfile';
import Button from '@ui/Button';
import React from 'react';

function HeaderButtons({ company }) {
  const user = useUserProfile();

  let recordShareClickPayload = {
    type: 'company_public_page',
    companyId: company.id,
    shareClick: {
      userId: user?.id,
      activeCommunityId: user?.activeCommunity?.id,
      location: user?.location,
    },
  };


  const setShowConnectModal = useConnectModalStore((state) => state.setOpen);

  const handleConnect = () => {
    setShowConnectModal(true, company);
  };

  return (
    <div className="flex gap-2 self-end px-6 lg:self-start lg:pl-0 lg:pr-4">
      <Button variant="filled" color="primary" onClick={handleConnect}>
        Connect
      </Button>
      <ShareButton variant="text" recordPayload={recordShareClickPayload} />
    </div>
  );
}

export default HeaderButtons;
